import { all, fork, put, takeLeading } from "typed-redux-saga";
import { Action, projectListActions } from "./project-list-store";
import { errorActions as errorActions } from "src/components/error-viewer/error-store";
import { call } from "redux-saga/effects";
import { ConfiguratorService, Model_AttributeDetailsGet, Model_ProjectGet } from "src/backend/openapi/v1";
import { applicationActions } from "src/components/application-store";

export function* getProjects(action: ReturnType<typeof projectListActions.getProjectsRequest>) {
  try {
    const result: Model_ProjectGet[] = yield call(ConfiguratorService.getApiV1ConfiguratorProjects, undefined, action.payload.customerId);
    yield put(projectListActions.getProjectsSuccess(result));
  } catch (error) {
    yield put(projectListActions.getProjectsFail());
    yield put(errorActions.addError(error));
  }
}

export function* watchGetProjects() {
  yield takeLeading(Action.GetProjectsRequest, getProjects);
}

export function* getProjectsAttributes(action: ReturnType<typeof projectListActions.getProjectsAttributesRequest>) {
  try {
    const result: Model_AttributeDetailsGet[] = yield call(ConfiguratorService.getApiV1ConfiguratorProjectsAttributes, undefined, action.payload.customerId);
    yield put(projectListActions.getProjectsAttributesSuccess(result));
  } catch (error) {
    yield put(errorActions.addError(error));
    yield put(projectListActions.getProjectsAttributesFail());
  }
}

export function* watchGetProjectsAttributes() {
  yield takeLeading(Action.GetProjectsAttributesRequest, getProjectsAttributes);
}

export function* deleteProject(action: ReturnType<typeof projectListActions.deleteProjectRequest>) {
  try {
    yield put(applicationActions.setWarningAction(undefined));
    yield put(applicationActions.setGlobalLoading(true));
    yield call(ConfiguratorService.deleteApiV1ConfiguratorProjects, action.payload.projectId, undefined, action.payload.customerId);
    yield put(applicationActions.setGlobalLoading(false));

    yield put(projectListActions.setShouldReload(true));
  } catch (error) {
    yield put(errorActions.addError(error));
  } finally {
    yield put(applicationActions.setGlobalLoading(false));
  }
}

export function* watchDeleteProject() {
  yield takeLeading(Action.DeleteProjectRequest, deleteProject);
}

export function* projectListSaga() {
  yield all([fork(watchDeleteProject), fork(watchGetProjects), fork(watchGetProjectsAttributes)]);
}
